// extracted by mini-css-extract-plugin
export default {"okButton":"okButton-dZyu9","link":"link-fE6ax","text":"text-jzz8d"};